<template>
  <b-col cols="12" sm="12">
    <div>
      <a class="btnVolver" @click="$router.push({ path: 'modelos' })" title="Cerrar">
        <feather id="btnX" type="arrow-left-circle"></feather>
      </a>
    </div>
    <b-card class="mx-auto" tile>
      <div v-if="!submitted">
        <span>*{{ this.$t("Gral.camposObligatorios") }}</span>
        <b-form @submit.stop.prevent="createModelo" style="z-index: 1">
          <b-col cols="12" sm="12">
            <div class="row">
              <b-col cols="12" sm="6">
                <label for="“marca”">{{ $t('vMarca.marca') }}* :</label>
                <b-form-select id="marca" v-model="selectedMarca" :options="marcas" value-field="id" text-field="marca"
                  required>
                  <template #first>
                    <b-form-select-option :value="null" disabled>
                      {{ $t("vMarca.elejirMarca") }}
                    </b-form-select-option>
                  </template>
                </b-form-select>
              </b-col>
              <b-col cols="12" sm="6">
                <label for="“nombre”">{{ $t('vModelo.modelo') }}* :</label>
                <b-form-input id="input-nombre" v-model="modelo.nombre" :state="validarModelo"
                  aria-describedby="input-nombre-help input-nombre-feedback" trim></b-form-input>
                <b-form-invalid-feedback id="input-nombre-feedback">
                  {{ $t('vModelo.msgModelo') }}
                </b-form-invalid-feedback>
              </b-col>
            </div>
            <div class="row">
              <div class="col-12 col-sm-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 d-lg-flex justify-content-lg-end">
                <b-btn color="primary" class="ancho-boton w-100" style="color: white" to="/Modelos">
                  {{ this.$t("Gral.cancelar") }}
                </b-btn>
              </div>
              <div class="col-12 col-sm-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 sepracion-div-boton-guardar">
                <b-btn variant="info" class="ancho-boton w-100" style="color: white" type="submit"
                  :disabled="!validarModelo">
                  {{ $t('vModelo.agregarModelo') }}
                </b-btn>
              </div>
            </div>
          </b-col>
        </b-form>
      </div>
    </b-card>
  </b-col>
</template>

<script src="js/main.js"></script>
<script>
import ModelosDataService from "../../../services/ModelosDataService";
import MarcasDataService from "../../../services/MarcasDataService";
import AccionesDataService from "../../../services/AccionesDataService";
import Crypto from '../../../services/Crypto';
import { verificarAcceso } from '../../../utils/Session';

export default {
  name: "add-modelo",
  data() {
    return {
      marcas: this.obtenerMarcasHabilitadas(),
      selectedMarca: null,
      modelo: {
        id: 0,
        nombre: "",
        marca: "",
        habilitado: true,
      },
      submitted: false,
      accion: "",
      usuarioLogueado: JSON.parse(sessionStorage.getItem("usuarioLogueado")),
      key: ""
    };
  },
  beforeCreate() {
    verificarAcceso();
    if (
      !sessionStorage.getItem("rol") ||
      sessionStorage.idRol === process.env.VUE_APP_ID_USUARIO_FINAL
    ) {
      this.$router.push({
        path: "/monitoreo",
      });
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "error",
        title: this.$t("vDispositivos.noPermisos"),
      });
    }
  },
  computed: {
    validarModelo() {
      return this.modelo.nombre.length >= 5 && this.modelo.nombre.trim() !== '' ? true : false;
    },
  },

  mounted() {
    this.key = sessionStorage.getItem('key')
  },

  methods: {
    obtenerMarcasHabilitadas() {
      MarcasDataService.getAllHabilitadas().then(async(response) => {
        this.marcas = await Crypto.desencriptar(response.data, this.key);
      });
    },

    async createModelo() {
      try {
        const data = {
          modelo: this.modelo.nombre,
          marca: this.marcas.find((item) => item.id === this.selectedMarca),
          habilitado: this.modelo.habilitado,
        };

        const response = await ModelosDataService.create(data, this.key)
        if(response.status === 200){
          this.accion = "Registró el modelo " + data.modelo;
          this.registrarAccion();
          this.$router.push("/modelos");

          this.alertSweet('success', 'Modelo registrado exitosamente.')
        }
      } catch (error) {
        this.alertSweet('error', 'Error al registrar el modelo.')
      }
    },

    registrarAccion() {
      var data = {
        usuario: this.usuarioLogueado,
        accion: this.accion + sessionStorage.infoDevice,
        fechaCreacion: new Date(),
        tipo: "accion",
      };
      AccionesDataService.create(data, this.key);
    },

    alertSweet(icon, message){
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener("mouseenter", this.$swal.stopTimer);
        toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: icon,
        title: message
      });
    },
  }
}
</script>

<style>
.myMargin {
  margin-left: 1rem;
}

.submit-form {
  max-width: 400px;
}

@media (max-width: 768px) {
  .btnVolver {
    position: absolute;
    top: -40px;
    left: 16px;
  }
}

@media (min-width: 769px) {
  .btnVolver {
    display: none !important;
  }
}

@media (max-width: 959px) {
  .sepracion-div-boton-guardar {
    margin-top: -12px;
  }
}

@media (min-width: 960px) {
  .sepracion-div-boton-guardar {
    margin-top: 0px;
  }
}

@media (min-width: 992px) {
  .ancho-boton {
    width: 300px !important;
  }
}
</style>
